
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('[data-mm-menu-button]');
  const nav = document.querySelector('[data-mm-mobile-nav]');
  if (button && nav) {
    button.addEventListener('click', function () {
      const open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
